import { render } from "./Aliplayer.vue?vue&type=template&id=30d27e33&scoped=true"
import script from "./Aliplayer.vue?vue&type=script&lang=js"
export * from "./Aliplayer.vue?vue&type=script&lang=js"

import "./Aliplayer.vue?vue&type=style&index=0&id=30d27e33&scoped=true&lang=scss"

import exportComponent from "D:\\work\\ocs\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d27e33"]])

export default __exports__